import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/tokens.css";
import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Enables offline/PWA install support.
serviceWorkerRegistration.register();
